module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "register-page"
    }
  }, [(!_vm.successfullyRegistered) ? _c('form', {
    attrs: {
      "id": "register-form"
    }
  }, [_c('h2', [_vm._v("Register a New Account")]), _vm._v(" "), _c('div', {
    staticClass: "register-form-fields"
  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? [_c('label', [_vm._v("Screen Name ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alias),
      expression: "alias"
    }],
    class: {
      invalid: _vm.aliasHasError
    },
    attrs: {
      "type": "text",
      "placeholder": "Screen Name"
    },
    domProps: {
      "value": (_vm.alias)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.alias = $event.target.value
      }, function($event) {
        _vm.aliasHasError = false
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: {
      invalid: _vm.emailHasError
    },
    attrs: {
      "type": "email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.emailHasError = false
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Verify Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailVerify),
      expression: "emailVerify"
    }],
    class: {
      invalid: _vm.emailHasError
    },
    attrs: {
      "type": "email",
      "placeholder": "Confirm Email Address"
    },
    domProps: {
      "value": (_vm.emailVerify)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.emailVerify = $event.target.value
      }, function($event) {
        _vm.emailHasError = false
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: {
      invalid: _vm.passwordHasError
    },
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.passwordHasError = false
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Verify Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordVerify),
      expression: "passwordVerify"
    }],
    class: {
      invalid: _vm.passwordHasError
    },
    attrs: {
      "type": "password",
      "placeholder": "Confiirm Password"
    },
    domProps: {
      "value": (_vm.passwordVerify)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordVerify = $event.target.value
      }, function($event) {
        _vm.passwordHasError = false
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recaptcha-container"
  }, [_c('div', {
    staticClass: "recpatcha-inner-container"
  }, [_c('div', {
    ref: "recaptchaContainer",
    staticClass: "g-recaptcha",
    attrs: {
      "data-sitekey": _vm.rcapt_sig_key
    }
  })])]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.formErrors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._v("Register Account")])])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.successfullyRegistered) ? _c('div', {
    attrs: {
      "id": "successful-registration"
    }
  }, [_c('h2', [_vm._v("Welcome to Develteam!")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Return to the Home Page")]), _vm._v("\n            |\n            "), _c('router-link', {
    attrs: {
      "to": ("/Developer/" + (_vm.loggedUser.stringUrl))
    }
  }, [_vm._v("Edit your Profile")])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4161fc6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Register/Register.vue
// module id = 861
// module chunks = 2